/**
 * Bug fila 100 (UAT 2026-08-25) — `acquireTokenSilent` de MSAL puede fallar porque Entra ID exige
 * reautenticación interactiva (MFA/Conditional Access), no porque el token esté simplemente vacío.
 * Antes ese caso se trataba igual que "todavía no hay sesión" (token '' -> 401 silencioso en
 * cualquier endpoint, con mensajes de error que no tienen nada que ver con la causa real).
 *
 * Clase compartida por los DOS clientes de API (`api/client.ts` y `api/recognition/client.ts`, este
 * último vía `auth/acquireToken.ts`) para que cualquier pantalla — o el banner global, para las que
 * no la manejan explícitamente — pueda distinguirlo y mostrar "tu sesión expiró" en vez de un error
 * genérico de la acción que se estaba haciendo.
 */
export class SessionExpiredError extends Error {
  constructor() {
    super('SessionExpired');
    this.name = 'SessionExpiredError';
  }
}
